@if (checking()) {
  <div
    class="relative flex items-center justify-center w-full h-screen overflow-hidden bg-white dark:bg-gray-900"
  >
    <div
      class="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-indigo-200/40 dark:bg-indigo-500/10 blur-3xl"
    ></div>
    <div
      class="absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-purple-200/40 dark:bg-purple-500/10 blur-3xl"
    ></div>

    <div class="relative flex flex-col items-center gap-6">
      <img
        src="/images/logo/logo.svg"
        alt="Logo"
        class="h-10 dark:hidden"
      />
      <img
        src="/images/logo/auth-logo.svg"
        alt="Logo"
        class="hidden h-10 dark:block"
      />

      <div class="relative grid h-16 w-16 place-items-center">
        <div
          class="absolute inset-0 rounded-full border-2 border-indigo-200 dark:border-indigo-500/20 animate-ping"
          style="animation-duration: 2s"
        ></div>
        <div
          class="absolute inset-2 rounded-full border-2 border-indigo-300 dark:border-indigo-500/30 animate-ping"
          style="animation-duration: 1.5s"
        ></div>
        <div
          class="grid h-12 w-12 place-items-center rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 shadow-lg shadow-indigo-500/30"
        >
          <i class="pi pi-spin pi-spinner text-xl text-white"></i>
        </div>
      </div>

      <div class="text-center">
        <p class="text-base font-medium text-gray-800 dark:text-white/90">
          Signing you in...
        </p>
        <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
          Please wait while we verify your credentials
        </p>
      </div>
    </div>
  </div>
} @else {
  <app-auth-page-layout>
    <app-signin-form class="flex flex-col flex-1" />
  </app-auth-page-layout>
}
<p-toast />
